import { atom } from 'recoil';

export const showChatWindowState = atom({
  key: 'showChatWindow',
  default: false,
});

export const newChatMessageState = atom({
  key: 'setNewChatMessageState',
  default: false,
});

export const roomNameState = atom({
  key: 'roomName',
  default: 'Paskaita',
});
